import React from 'react'
import { DepartmentConsumer } from '#src/context/department'
import { DepartmentReviewsComponent } from '#src/generated/graphql'
import { withAnalytics, WithAnalyticsProps } from '#src/containers/Analytics'
import CuratedReviews from '../CuratedReviews'

const ShopperApprovedWidget: React.SFC<WithAnalyticsProps> = ({ analytics }) => {
  return (
    <DepartmentConsumer>
      {({ department }) => {
        if (!department) {
          return null
        }

        return (
          <DepartmentReviewsComponent
            variables={{
              id: department.id
            }}
          >
            {({ data }) => {
              if (data && data.department && data.department.reviewSummary) {
                const reviewSummary = data.department.reviewSummary

                /**
                 * Require at least five reviews for a department before we show this widget
                 */
                if (reviewSummary.totalReviews < 5) {
                  return null
                }

                const handleClick = () => {
                  analytics
                    ? () => {
                        analytics.shopperApprovedWidgetClicked({
                          department_slug: department.slug
                        })
                      }
                    : () => {}
                }

                const formattedAverageRating = reviewSummary.averageRating
                  ? Math.ceil(reviewSummary.averageRating)
                  : null

                return (
                  <CuratedReviews
                    isInternal={true}
                    departmentLabel={department.displayName}
                    url={`/reviews/${department.slug}`}
                    handleClick={handleClick}
                    icon={true}
                    logo={false}
                    showAllStars={true}
                    showReviewNumbers={true}
                    averageRating={formattedAverageRating}
                    reviewNumber={reviewSummary.totalReviews}
                  />
                )
              } else {
                return null
              }
            }}
          </DepartmentReviewsComponent>
        )
      }}
    </DepartmentConsumer>
  )
}

export default withAnalytics(ShopperApprovedWidget)
